module.exports = __webpack_public_path__ + "img/ach.a1a12200.svg";